export class TerminalDeliveryModel {
    type: number; // 0 = PDV; 1 = Correo; 2 = Mensajeria
    deliveryPrice: number;
    pdvData: any;
    mailData: any;
    courierData: any;
}
